import React from "react"

interface LinkProperties {
  term?: string
  category?: string
  videoId?: string
  startSec?: string
  endSec?: string
}

export const useShareableLink = () => {
  return React.useCallback((props: LinkProperties) => {
    const { term, category, videoId, startSec, endSec } = props
    let queryItemsExist = false
    const params = new URLSearchParams(window.location.search)
    if (term) {
      queryItemsExist = true
      setParams(params, "term", term)
    }

    if (category) {
      queryItemsExist = true
      setParams(params, "c", category)
    }

    if (videoId != null) {
      queryItemsExist = true
      setOrDeleteParams(params, "videoId", videoId)
    }

    if (startSec != null) {
      queryItemsExist = true
      setOrDeleteParams(params, "startSec", startSec)
    }

    if (endSec != null) {
      queryItemsExist = true
      setOrDeleteParams(params, "endSec", endSec)
    }

    const url = `${window.location.origin}${
      window.location.pathname
    }?${params.toString()}`
    // update the address bar, so user state survives page refresh.
    if (queryItemsExist) window.history.pushState({}, "", url)

    // set the shareable link
    return url
  }, [])
}

function setParams(u: URLSearchParams, key: string, value: string) {
  u.delete(key)
  u.append(key, value.trim())
}

function setOrDeleteParams(u: URLSearchParams, key: string, value: string) {
  u.delete(key)
  if (value.trim()) {
    u.append(key, value.trim())
  }
}
